export default {
  state: {
    innerHeightRem: 0,
    loading: false,
  },
  mutations: {
    setinnerHeightRem: (state, innerHeightRem) => {
      state.innerHeightRem = innerHeightRem
    },
    setloading: (state, loading) => {
      state.loading = loading
    },
  },
  actions: {
    SET_INNER_HEIGHT_REM: (context, innerHeightRem) => { // 设置高度rem
      context.commit('setinnerHeightRem', innerHeightRem)
    },
    SET_LOADING: (context, loading) => { // 设置loading
      context.commit('setloading', loading)
    },
  }
}
